import React from 'react';
import { Typography } from '@mui/material';

const PlaybackControlsJoyrideContent = (props) => {
    return (
        <Typography variant='body2' align='left'>
            Play, pause, and seek through the video preview. 
            Pressing the spacebar will also play and pause the preview if no other controls are selected.
            If the preview keeps buffering, mute the volume and that should improve the performance.
        </Typography>
    );
};

export default PlaybackControlsJoyrideContent;
